import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import useOfferCartOrderData from "./useOfferCartOrderData.js";
import { useSelector } from "react-redux";
import { getFlight } from "../store/flightDetails/selectors.js";
import { getOrder } from "../store/order/selectors.js";
export default function useSearchCabinClass() {
    const location = useLocation();
    const offerCartOrderData = useOfferCartOrderData();
    const flight = useSelector(getFlight);
    const order = useSelector(getOrder);
    const offerToken = useMemo(() => flight?.token, [flight]);
    const orderToken = useMemo(() => order?.orderToken, [order]);
    const searchCabinClass = useMemo(() => {
        const params = new URLSearchParams(location.search);
        const paramCabinClass = params.get("cabinClass") || undefined;
        const storedOfferCabinClass = offerCartOrderData.get(offerToken).cabinClass;
        const storedOrderCabinClass = offerCartOrderData.get(orderToken).cabinClass;
        return paramCabinClass || storedOfferCabinClass || storedOrderCabinClass;
    }, [offerToken, orderToken, location, offerCartOrderData]);
    return { searchCabinClass };
}
